<template>
  <input
    :id="'search-input-' + searchType"
    :ref="(el) => searchInputRef = el"
    v-model="debouncedQuery"
    :aria-activedescendant="'search-item-' + selectedIndex"
    aria-controls="search-list"
    type="search"
    :placeholder="placeholder"
    class="search-input"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    maxlength="512"
    autofocus
  >
</template>

<script>
/* Components */
import { connectSearchBox } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch/vue3/es';

/**
 * Debouncing in Algolia's Vue InstantSearch
 *
 * @see https://www.algolia.com/doc/guides/building-search-ui/going-further/improve-performance/vue/#debouncing
 */
export default {
  mixins: [createWidgetMixin({ connector: connectSearchBox })],

  inject: {
    searchType: {
      default: 'global',
    },
  },

  props: {
    delay: {
      type: Number,
      default: 200,
      required: false,
    },

    placeholder: {
      type: String,
      default: 'Search for a topic',
      required: false,      
    },

    shouldClearInput: {
      type: Boolean,
      required: false,
    },

    selectedIndex: {
      type: Number,
      default: 0,
      required: false,
    },
  },

  emits: {
    'clear-input': null,
  },

  data() {
    return {
      timer: null,
      query: '',
      searchInputRef: null,
    };
  },

  computed: {
    debouncedQuery: {
      get() {
        return this.query;
      },
      set(val) {
        this.query = val;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.state.refine(this.query);
        }, this.delay);
      },
    },
  },

  watch: {
    shouldClearInput(newVal) {
      if (newVal === true) {
        this.query = this.state.clear();

        this.$nextTick(() => {
          this.$emit('clear-input');

          /* Return focus to input field after clear */
          this.searchInputRef.focus();
        });
      }
    },
  },

  unmounted() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
};
</script>